import React from 'react';

const LazyRodeoEvent = React.lazy(() =>
  import(/* webpackChunkName: "RodeoEvent" */ './event')
);

const OverUnderEvent = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyRodeoEvent {...props} />
  </React.Suspense>
);

export default OverUnderEvent